import { gql } from 'graphql-tag';
import { ORDER_FRAGMENT } from '../fragments';

/**
 * 获取物流详情
 */
export const fetchLogisticsDocument = gql`
  query logistics($orderId: ID!) {
    logistics(orderId: $orderId) {
      id
      logisticCode
      state
      order {
        ...Order
      }
      company
      logisticInfo {
        traces {
          acceptStation
          acceptTime
        }
      }
    }
  }
  ${ORDER_FRAGMENT}
`;
